import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\TemplateDashboard\AddTemplateDashboardElementController::__invoke
* @see app/Http/Controllers/TemplateDashboard/AddTemplateDashboardElementController.php
* @route '/api/template-dashboard/{template_dashboard}/{rowId}/add'
*/
const AddTemplateDashboardElementController = (args: { template_dashboard: string | number | { id: string | number }, rowId: string | number } | [template_dashboard: string | number | { id: string | number }, rowId: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddTemplateDashboardElementController.url(args, options),
    method: 'post',
})

AddTemplateDashboardElementController.definition = {
    methods: ["post"],
    url: '/api/template-dashboard/{template_dashboard}/{rowId}/add',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\TemplateDashboard\AddTemplateDashboardElementController::__invoke
* @see app/Http/Controllers/TemplateDashboard/AddTemplateDashboardElementController.php
* @route '/api/template-dashboard/{template_dashboard}/{rowId}/add'
*/
AddTemplateDashboardElementController.url = (args: { template_dashboard: string | number | { id: string | number }, rowId: string | number } | [template_dashboard: string | number | { id: string | number }, rowId: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            template_dashboard: args[0],
            rowId: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        template_dashboard: typeof args.template_dashboard === 'object'
        ? args.template_dashboard.id
        : args.template_dashboard,
        rowId: args.rowId,
    }

    return AddTemplateDashboardElementController.definition.url
            .replace('{template_dashboard}', parsedArgs.template_dashboard.toString())
            .replace('{rowId}', parsedArgs.rowId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\TemplateDashboard\AddTemplateDashboardElementController::__invoke
* @see app/Http/Controllers/TemplateDashboard/AddTemplateDashboardElementController.php
* @route '/api/template-dashboard/{template_dashboard}/{rowId}/add'
*/
AddTemplateDashboardElementController.post = (args: { template_dashboard: string | number | { id: string | number }, rowId: string | number } | [template_dashboard: string | number | { id: string | number }, rowId: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddTemplateDashboardElementController.url(args, options),
    method: 'post',
})

export default AddTemplateDashboardElementController